/**
 * Sleep Karma Custom JavaScript
 * Includes dropdown menu functionality for the header navigation
 */



document.addEventListener('DOMContentLoaded', function() {
  // Force activate all video slides on mobile for sound toggle visibility
  if (window.innerWidth <= 899) {
    const videoSlides = document.querySelectorAll('.video-reels [data-swiper-slide]');
    videoSlides.forEach(slide => {
      slide.classList.add('active');
    });
  }
});

// Add dropdown menu functionality
document.addEventListener('DOMContentLoaded', function() {
  // Function to create and apply dropdown menu
  function createSleepProductsDropdown() {
    // First try to find the menu item using the class structure from the screenshot
    const sleepProductsItem = document.querySelector('li.wt-header__nav-teaser__item a[href*="sleep-products"]')?.closest('li');
    
    if (sleepProductsItem) {
      console.log('Sleep Products menu item found:', sleepProductsItem);
      
      // Check if the submenu already exists
      if (!sleepProductsItem.querySelector('.sleep-products-dropdown')) {
        // Create a dropdown menu
        const dropdown = document.createElement('ul');
        dropdown.className = 'sleep-products-dropdown';
        
        // Add menu items - these should match your Shopify menu structure
        const menuItems = [
          { text: 'Mouth Tape', url: (document.body.classList.contains('template-page-pdp-w') || document.body.classList.contains('template-page-lp-presell-wellness')) ? '/pages/mouth-tape-w' : '/pages/mouth-tape-a' },
          { text: 'Nose Tape', url: '/products/nose-tape' },
                              { text: 'Accessories', url: '/collections/sleep-accessories' },
                    { text: 'See More', url: '/collections/sleep-products' }


        ];
        
        menuItems.forEach(item => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = item.url;
          a.textContent = item.text;
          li.appendChild(a);
          dropdown.appendChild(li);
        });
        
        // Add the dropdown to the menu item
        sleepProductsItem.appendChild(dropdown);
        
        // Position the dropdown properly
        sleepProductsItem.style.position = 'relative';
      }
    } else {
      console.log('Sleep Products menu item not found, trying alternative selectors');
      
      // Try alternative selector
      const altSleepProductsItem = document.querySelector('a[href*="sleep-products"]')?.closest('li');
      if (altSleepProductsItem) {
        console.log('Alternative Sleep Products menu item found:', altSleepProductsItem);
        
        // Similar approach as above
        if (!altSleepProductsItem.querySelector('.sleep-products-dropdown')) {
          const dropdown = document.createElement('ul');
          dropdown.className = 'sleep-products-dropdown';
          
          const menuItems = [
            { text: 'Mouth Tape', url: (document.body.classList.contains('template-page-pdp-w') || document.body.classList.contains('template-page-lp-presell-wellness')) ? '/pages/mouth-tape-w' : '/pages/mouth-tape-a' },
            { text: 'Nose Tape', url: '/products/nose-tape' }
          ];
          
          menuItems.forEach(item => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = item.url;
            a.textContent = item.text;
            li.appendChild(a);
            dropdown.appendChild(li);
          });
          
          altSleepProductsItem.appendChild(dropdown);
          altSleepProductsItem.style.position = 'relative';
        }
      }
    }
  }
  
  // Initialize when DOM is loaded
  createSleepProductsDropdown();
  
  // Re-initialize on window resize and periodically check (in case of late loading)
  window.addEventListener('resize', createSleepProductsDropdown);
  
  // Check again after a delay, in case the menu loads dynamically
  setTimeout(createSleepProductsDropdown, 1000);

  // Add additional custom code here if needed in the future
});

// Add Guides dropdown (mirrors the Shop dropdown above; reuses the
// .sleep-products-dropdown styling + its generic `li:hover` show rule)
document.addEventListener('DOMContentLoaded', function() {
  function createGuidesDropdown() {
    const guidesItem = document.querySelector('li.wt-header__nav-teaser__item a[href*="/pages/guides"]')?.closest('li');

    if (guidesItem && !guidesItem.querySelector('.sleep-products-dropdown')) {
      const dropdown = document.createElement('ul');
      dropdown.className = 'sleep-products-dropdown guides-dropdown';

      const menuItems = [
        { text: 'Start Here: Mouth Taping 101', url: '/pages/learn-about-mouth-tape' },
        { text: 'Mouth Taping', url: '/pages/mouth-taping-guide' },
        { text: 'Nasal Breathing', url: '/pages/nasal-breathing-guide' },
        { text: 'How to Stop Snoring', url: '/pages/how-to-stop-snoring' },
        { text: 'Sleep Apnea & Safety', url: '/pages/sleep-apnea-guide' },
        { text: 'Better Sleep', url: '/pages/better-sleep-guide' }
      ];

      menuItems.forEach(item => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = item.url;
        a.textContent = item.text;
        li.appendChild(a);
        dropdown.appendChild(li);
      });

      guidesItem.appendChild(dropdown);
      guidesItem.style.position = 'relative';
    }
  }

  createGuidesDropdown();
  window.addEventListener('resize', createGuidesDropdown);
  setTimeout(createGuidesDropdown, 1000);
});


// move title to top


/*
 document.addEventListener('DOMContentLoaded', () => {
 console.log('JavaScript is running');

  // Select the necessary elements
  const wrapper = document.querySelector('.wt-product__wrapper');
  const productMain = document.querySelector('.wt-product__main');
  const gallery = document.querySelector('[id^="MediaGallery-"]'); // This will match any ID that starts with MediaGallery-
  const productInfo = productMain ? productMain.querySelector('.wt-product__info') : null;
  const wtProduct = wrapper ? wrapper.querySelector('.wt-product') : null;

  console.log('Wrapper:', wrapper);
  console.log('Product Main:', productMain);
  console.log('Gallery:', gallery);
  console.log('Product Info:', productInfo);
  console.log('Wt Product:', wtProduct);

  if (wrapper && productMain && gallery && productInfo && wtProduct) {
    // Get all blocks inside wt-product__info
    const blocks = Array.from(productInfo.children);
    console.log('All Blocks:', blocks);

    // Find the title block
    const titleBlock = blocks.find(block => block.querySelector('.wt-product__name'));
    console.log('Title Block:', titleBlock);

    // Find the text block by class
    const textBlock = blocks.find(block => block.classList.contains('wt-product__text-block'));
    console.log('Text Block:', textBlock);
    
    // Find the star rating block
    const starRatingBlock = blocks.find(block => 
      block.id && block.id.includes('okendo_star_rating') || // Find by okendo star rating ID
      (block.classList && (
        block.classList.contains('shopify-app-block') || // Check for shopify app block class
        block.querySelector('[id*="okendo_star_rating"]') || // Find elements with okendo ID
        block.querySelector('[data-oke-reviews-version]') // Find by okendo attributes
      ))
    );
    console.log('Star Rating Block:', starRatingBlock);
    
    // Find the promo blocks (BEST SELLER and AWARD WINNING)
    // Target the parent elements with data-block-id that contain .wt-product__promo
    const promoBlocks = blocks.filter(block => 
      block.hasAttribute('data-block-id') && 
      block.getAttribute('data-block-id').startsWith('promo_')
    );
    console.log('Promo Blocks:', promoBlocks);

    if (titleBlock && textBlock) {
      // Create a wrapper div
      const titleWrapper = document.createElement('div');
      titleWrapper.classList.add('product-title-wrapper');

      // Create a container for promo blocks
      const promoContainer = document.createElement('div');
      promoContainer.classList.add('promo-container');
      
      // Add the promo blocks to the container
      if (promoBlocks && promoBlocks.length > 0) {
        promoBlocks.forEach(promoBlock => {
          promoContainer.appendChild(promoBlock);
        });
      }
      
      // Add the promo container to the title wrapper
      titleWrapper.appendChild(promoContainer);
      
      // Add the title block
      titleWrapper.appendChild(titleBlock);
      
      // Add the star rating block between title and text if it exists
      if (starRatingBlock) {
        titleWrapper.appendChild(starRatingBlock);
      }
      
      // Add the text block
      titleWrapper.appendChild(textBlock);

      // Insert the wrapper into the wt-product div, before the gallery
      wtProduct.insertBefore(titleWrapper, gallery);
      console.log('Title wrapper moved successfully');

      // Log the updated DOM structure
      console.log('Updated wt-product children:', Array.from(wtProduct.children));

      // On desktop, move the title wrapper back into wt-product__main
      if (window.innerWidth > 900) {
        productMain.insertBefore(titleWrapper, productInfo);
      }

      // Add a resize listener to handle window resizing
      window.addEventListener('resize', () => {
        if (window.innerWidth > 900) {
          productMain.insertBefore(titleWrapper, productInfo);
        } else {
          wtProduct.insertBefore(titleWrapper, gallery);
        }
      });
    } else {
      console.log('Title or Text block not found');
    }
  } else {
    console.log('One or more required elements not found');
  }
});

*/


document.addEventListener('DOMContentLoaded', function() {
  const duplicateButton = document.querySelector('.js-start-now-duplicate');
  const scrollTriggerPoint = 1000;
  
  if (duplicateButton) {
    // Add click functionality
    duplicateButton.addEventListener('click', function() {
      const originalButton = document.querySelector('#ProductSubmitButton-template--18998313222385__main');
      if (originalButton) {
        originalButton.click();
      } else {
        const submitButton = document.querySelector('button[name="add"]');
        if (submitButton) {
          submitButton.click();
        }
      }
    });
    
    // Function to check if cart drawer is open
    function isCartDrawerOpen() {
      const cartDrawer = document.querySelector('#CartDrawer');
      return cartDrawer && cartDrawer.classList.contains('is-open');
    }
    
    // Function to toggle button visibility based on scroll position AND cart drawer state
    function toggleButtonVisibility() {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      const shouldShowBasedOnScroll = scrollPosition > scrollTriggerPoint;
      const cartDrawerOpen = isCartDrawerOpen();
      
      // Show button only if scrolled enough AND cart drawer is closed
      if (shouldShowBasedOnScroll && !cartDrawerOpen) {
        duplicateButton.classList.add('show');
      } else {
        duplicateButton.classList.remove('show');
      }
    }
    
    // Scroll detection with throttling
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(toggleButtonVisibility, 10);
    });
    
    // Watch for cart drawer changes using MutationObserver
    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            toggleButtonVisibility();
          }
        });
      });
      
      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    // Also listen for body class changes (some themes toggle cart state on body)
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          toggleButtonVisibility();
        }
      });
    });
    
    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Initial check
    toggleButtonVisibility();
  }
});

// Simple Video Sound Toggle - Click any video to toggle sound (with persistent state)
document.addEventListener('DOMContentLoaded', function() {
  
  function initVideoSoundToggle() {
    // Find all videos in Video Reels V2 sections
    const videos = document.querySelectorAll('video-reels video, .testimonial-video-reels-v2__container video');
    
    videos.forEach(video => {
      // Remove any existing click listeners
      video.removeEventListener('click', toggleVideoSound);
      
      // Add click listener
      video.addEventListener('click', toggleVideoSound);
      
      // Make it look clickable
      video.style.cursor = 'pointer';
    });
  }
  
  function toggleVideoSound(event) {
    const clickedVideo = event.target;
    
    // Find the Video Reels V2 container this video belongs to
    const videoReelsContainer = clickedVideo.closest('video-reels');
    
    if (!videoReelsContainer) return;
    
    // Toggle muted state
    const newMutedState = !clickedVideo.muted;
    
    // Apply the same muted state to ALL videos in this Video Reels V2 section
    const allVideosInSection = videoReelsContainer.querySelectorAll('video');
    allVideosInSection.forEach(video => {
      video.muted = newMutedState;
    });
    
    // Update the container's data attribute to track state
    const container = videoReelsContainer.querySelector('.wt-slider__container');
    if (container) {
      container.dataset.sound = newMutedState ? 'off' : 'on';
    }
    
    // Show simple feedback
    const feedback = newMutedState ? '🔇' : '🔊';
    showFeedback(feedback);
    
    // Don't interfere with video playback
    event.preventDefault();
    event.stopPropagation();
  }
  
  function showFeedback(icon) {
    // Remove any existing feedback
    const existingFeedback = document.querySelector('.video-sound-feedback');
    if (existingFeedback) {
      existingFeedback.remove();
    }
    
    // Create feedback element
    const feedback = document.createElement('div');
    feedback.className = 'video-sound-feedback';
    feedback.innerHTML = icon;
    feedback.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 48px;
      z-index: 9999;
      pointer-events: none;
      animation: fadeInOut 1s ease;
    `;
    
    // Add CSS animation
    if (!document.querySelector('#video-feedback-styles')) {
      const style = document.createElement('style');
      style.id = 'video-feedback-styles';
      style.textContent = `
        @keyframes fadeInOut {
          0% { opacity: 0; transform: translate(-50%, -50%) scale(0.5); }
          50% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
          100% { opacity: 0; transform: translate(-50%, -50%) scale(0.5); }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(feedback);
    
    // Remove after animation
    setTimeout(() => {
      if (feedback.parentNode) {
        feedback.remove();
      }
    }, 1000);
  }
  
  // Function to sync video states when carousel changes
  function syncVideoStates() {
    const videoReelsSections = document.querySelectorAll('video-reels');
    
    videoReelsSections.forEach(section => {
      const container = section.querySelector('.wt-slider__container');
      const videos = section.querySelectorAll('video');
      
      if (container && videos.length > 0) {
        // Get the stored sound state
        const soundState = container.dataset.sound;
        const shouldBeMuted = soundState === 'off';
        
        // Apply to all videos in this section
        videos.forEach(video => {
          video.muted = shouldBeMuted;
        });
      }
    });
  }
  
  // Initialize immediately
  initVideoSoundToggle();
  
  // Re-initialize after a delay (for dynamic content)
  setTimeout(() => {
    initVideoSoundToggle();
    syncVideoStates();
  }, 2000);
  
  // Re-initialize when swiper changes (for carousel navigation)
  document.addEventListener('click', function(e) {
    if (e.target.closest('.swiper-button-next, .swiper-button-prev')) {
      setTimeout(() => {
        initVideoSoundToggle();
        syncVideoStates();
      }, 500);
    }
  });
  
  // Also sync when slides change (catch any swiper slide changes)
  const observer = new MutationObserver(function(mutations) {
    let shouldSync = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'class' && 
          mutation.target.classList.contains('swiper-slide')) {
        shouldSync = true;
      }
    });
    if (shouldSync) {
      setTimeout(syncVideoStates, 100);
    }
  });
  
  observer.observe(document, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
});